export default "__VITE_ASSET__DZB3YyOU__"